import { transparentize } from 'polished'
import styled, { css } from 'styled-components'

import { Link } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	link?: boolean
	slim?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const transparentStyling = css<Props>`
	display: block;
	color: ${({ type = 'primary', theme }) => theme.color[type]};
	background-color: transparent;
	font-weight: ${helpers.font.weight.medium};
	font-family: ${helpers.font.family.header};
	font-size: ${({ slim, theme }) => (slim ? theme.font.size.base : theme.font.size.large)};
	line-height: ${({ slim, theme }) => (slim ? theme.font.size.base : theme.font.size.large)};
	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 12px;
	min-width: 140px;
	height: ${({ slim }) => (slim ? '34px' : '40px')};
	padding: 9px 30px;
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;

	&:is(:focus-visible, :hover) {
		color: ${({ type = 'primary', theme }) => theme.color[type]};
		text-decoration: none;
		background-color: ${({ type = 'primary', link, theme }) => !link && transparentize(0.83, theme.color[type])};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}
`

export const Transparent = styled(Link)<Props>`
	${transparentStyling};
`
